import megatron from 'megatron';

export const getSimilarHotelData = ({url}) => {
    const headers = {
      
    };
    const type = 'GET';
    const credentials = 'include';
    const name = 'similar hotels api'
    return megatron({
        url,
        name,
        type,
        headers,
        credentials
    });
}
